import styled from 'styled-components';
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import { usePaginatedBlogSubRoutes } from '_hooks';
import { theme } from '_constants/theme';
import { getBlogTags } from '_helpers/blog';

import * as Layout from '_components/atomic/layouts';
import Paginate from '_components/atomic/Paginate';
import Select from './TopicsFilter/Select';
import StartBanner from './StartBanner';
import TopicsFilter from './TopicsFilter';
import Articles from './Articles';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large24X * 10 + 80}px;
  width: 100%;

  padding-top: ${theme.spaces.large4X}px;
  padding-bottom: ${theme.spaces.large4X}px;

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.largeX}px;
    padding-bottom: ${theme.spaces.largeX}px;
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
  }
`;

const StyledArticlesContainer = styled.div`
  @media ${theme.devices.tablet} {
  }
`;

const StyledPaginateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${theme.devices.tablet} {
    justify-content: center;
  }
`;

const StyledSelectContainer = styled.div`
  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const BlogGallerySection = () => {
  const [postsPerPage, setPostsPerPage] = useState(9);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [tags, setTags] = useState(getBlogTags());

  const { subRoutes, pageCount } = usePaginatedBlogSubRoutes({
    currentPageIndex,
    postsPerPage,
    tags,
  });

  const handleFilterChange = (tags) => {
    setTags(tags);
    window.scroll({ top: -100, left: 0, behavior: 'smooth' });
  };

  const handlePostsPerPageChange = (e) => {
    const { value } = e.target;
    setPostsPerPage(value);
    window.scroll({ top: -100, left: 0, behavior: 'smooth' });
  };

  const handlePageChange = (idx) => {
    setCurrentPageIndex(idx);
    window.scroll({ top: -100, left: 0, behavior: 'smooth' });
  };

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Layout.Card.Text
          size={theme.fontSizes.large10X}
          color={theme.colors.indigo[800]}
          boldest
          centered
          desktop
        >
          Resource Center
        </Layout.Card.Text>
        <Layout.Divider desktop />
        <Layout.Card.Text
          size={theme.fontSizes.large6X}
          color={theme.colors.indigo[800]}
          boldest
          centered
          mobile
        >
          Resource Center
        </Layout.Card.Text>
        <Row>
          <Col xs={12} md={3}>
            <TopicsFilter tags={getBlogTags()} onChange={handleFilterChange} />
          </Col>
          <Col xs={12} md={9}>
            <StyledArticlesContainer>
              <Articles subRoutes={subRoutes.slice(0, 6)} />
              <StartBanner />
              <Articles subRoutes={subRoutes.slice(6)} />
            </StyledArticlesContainer>
            <Layout.Divider size={theme.spaces.largeX} />
            <StyledPaginateContainer>
              <StyledSelectContainer>
                <Select
                  options={[
                    { title: '6 posts/page', value: 6 },
                    { title: '9 posts/page', value: 9 },
                    { title: '12 posts/page', value: 12 },
                  ]}
                  value={postsPerPage}
                  onChange={handlePostsPerPageChange}
                />
              </StyledSelectContainer>
              <Paginate
                currentPage={currentPageIndex}
                pageCount={pageCount}
                onPageChange={handlePageChange}
              />
            </StyledPaginateContainer>
          </Col>
        </Row>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default BlogGallerySection;
